import { POINTS_REASONS } from '@cult/domain';
import { z } from 'zod';

export const PointsLedgerEntrySchema = z.object({
  id: z.string(),
  amount: z.number(),
  reason: z.nativeEnum(POINTS_REASONS),
  ideaId: z.string().nullable(),
  monthKey: z.string(),
  createdAt: z.string(),
});
export type PointsLedgerEntry = z.infer<typeof PointsLedgerEntrySchema>;

export const PointsBalanceResponseSchema = z.object({
  balance: z.number(),
  monthEarned: z.number(),
  history: z.array(PointsLedgerEntrySchema),
});
export type PointsBalanceResponse = z.infer<typeof PointsBalanceResponseSchema>;

export const PointsSummaryResponseSchema = z.object({
  balance: z.number(),
  monthEarned: z.number(),
});
export type PointsSummaryResponse = z.infer<typeof PointsSummaryResponseSchema>;
